<template>
  <div class="main-body" v-loading="loading">
    <div class="notice-edit">
      <div class="notice-edit-btn">
        <el-row :gutter="20">
          <el-col :span="14">
            <el-button type="primary" @click="preview" size="medium">在线预览</el-button>
            <el-button type="danger" @click="insertOrUpdateNotice" size="medium">立即保存</el-button>
          </el-col>
          <el-col :span="10" style="text-align: right;line-height: 36px;">
            <el-switch
              v-model="noticeEnable"
              active-text="消息开启"
              inactive-text="消息关闭"
              @change="insertOrUpdateNotice">
            </el-switch>
          </el-col>
        </el-row>
      </div>
      <quill-editor ref="myTextEditor" v-model="content" :options="editorOption"></quill-editor>
    </div>

    <div class="notice-preview">
      <el-dialog :visible.sync="previewEnable" width="650px">
        <div class="ql-snow">
          <div class="ql-editor" v-html="content">
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { quillEditor, Quill } from 'vue-quill-editor';
  import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
  import { doGetNotice, doInsertOrUpdateNotice } from '@/utils/server'

  Quill.register('modules/ImageExtend', ImageExtend);

  export default {
    name: "edit",
    components: {
      quillEditor
    },
    data() {
      return {
        loading: false,
        noticeEnable: true,
        previewEnable: false,
        content: '',
        editorOption: {
          placeholder: '编辑消息内容',
          modules: {
            ImageExtend: {
              loading: true,  // 可选参数 是否显示上传进度和提示语
              name: 'imageFile',  // 图片参数名
              size: 3,  // 可选参数 图片大小，单位为M，1M = 1024kb
              action: process.env.SERVER_ADDRESS + '/api/notice/uploadImg',  // 服务器地址, 如果action为空，则采用base64插入图片
              response: (res) => {
                return res.data
              },
              headers: (xhr) => {
              },  // 可选参数 设置请求头部
              start: () => {
              },  // 可选参数 自定义开始上传触发事件
              end: () => {
              },  // 可选参数 自定义上传结束触发的事件，无论成功或者失败
              error: () => {
              },  // 可选参数 自定义网络错误触发的事件
              change: (xhr, formData) => {
              } // 可选参数 选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
            },
            toolbar: {
              container: [
                [ "bold", "italic", "underline", "strike" ], // toggled buttons
                [ "blockquote", "code-block" ],

                [ { header: 1 }, { header: 2 } ], // custom button values
                [ { list: "ordered" }, { list: "bullet" } ],
                [ { script: "sub" }, { script: "super" } ], // superscript/subscript
                [ { indent: "-1" }, { indent: "+1" } ], // outdent/indent
                [ { direction: "rtl" } ], // text direction

                [ { size: [ "small", false, "large", "huge" ] } ], // custom dropdown
                [ { header: [ 1, 2, 3, 4, 5, 6, false ] } ],

                [ { color: [] }, { background: [] } ], // dropdown with defaults from theme
                [ { font: [] } ],
                [ { align: [] } ],
                [ "link" ],
                [ "image" ]
              ],
              handlers: {
                image: function () {
                  QuillWatch.emit(this.quill.id);
                }
              }
            }
          }
        }
      }
    },
    methods: {
      onEditorChange({ editor, html, text }) {
        this.content = html;
      },
      preview() {
        this.previewEnable = true;
      },
      getNotice() {
        this.loading = true;
        doGetNotice({}).then(response => {
          if (response.data) {
            this.noticeEnable = response.data.noticeEnable === '1';
            this.content = response.data.noticeContent;
          }
          this.loading = false;
          console.log(response)
        });
      },
      insertOrUpdateNotice() {
        this.loading = true;
        let request = {
          noticeEnable: this.noticeEnable ? '1' : '0',
          noticeContent: this.content
        };
        doInsertOrUpdateNotice(request).then(response => {
          this.loading = false;
        });
      }
    },
    mounted() {
      this.getNotice();
    }
  }
</script>

<style scoped>
  .main-body {
    width: 650px;
    margin: 0 auto;
  }

  .notice-preview /deep/ .el-dialog__body {
    padding: 0;
  }

  .notice-edit .notice-edit-btn {
    margin: 15px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/notice/edit.vue